import React, { useState, useEffect } from 'react';
import matchService from '../services/matchService';
import teamService from '../services/teamService';
import tournamentService from '../services/tournamentService';
import { useNavigate } from 'react-router-dom';

const CreateMatch = () => {
	const [teams, setTeams] = useState([]);
	const [tournaments, setTournaments] = useState([]);
	const [homeTeam, setHomeTeam] = useState('');
	const [awayTeam, setAwayTeam] = useState('');
	const [tournament, setTournament] = useState('');
	const [matchType, setMatchType] = useState('FOOTBALL');
	const [date, setDate] = useState('');
	const [homeTeamPoints, setHomeTeamPoints] = useState(0);
	const [awayTeamPoints, setAwayTeamPoints] = useState(0);
	const [drawPoints, setDrawPoints] = useState(0);
	const [sportDbApiId, setSportDbApiId] = useState(0);
	const [matchStatus, setMatchStatus] = useState('NOT_STARTED');
	const [error, setError] = useState('');
	const navigate = useNavigate();

	useEffect(() => {
		const fetchData = async () => {
			try {
				const [teamsData, tournamentsData] = await Promise.all([
					teamService.getAllTeams(),
					tournamentService.getAllTournaments(),
				]);
				setTeams(teamsData);
				setTournaments(tournamentsData);
			} catch (err) {
				console.error('Failed to fetch data:', err);
				setError('Failed to load data');
			}
		};

		fetchData();
	}, []);

	const handleSubmit = async (e) => {
		e.preventDefault();

		const newMatch = {
			homeTeam: { id: homeTeam },
			awayTeam: { id: awayTeam },
			tournament: { id: tournament },
			sportType: matchType,
			date: date,
			homeTeamPoints,
			awayTeamPoints,
			drawPoints,
			sportDbApiId,
			matchStatus,
		};

		try {
			await matchService.createMatch(newMatch);
			alert('Match created successfully!');
			navigate('/matches');
		} catch (err) {
			setError('Failed to create match');
			console.error(err);
		}
	};

	const filteredTeams = teams.filter((team) => team.sportType === matchType);
	const filteredTournaments = tournaments.filter(
		(tournament) => tournament.sportType === matchType
	);

	return (
		<div>
			<h2>Create New Match</h2>
			{error && <p style={{ color: 'red' }}>{error}</p>}
			<form onSubmit={handleSubmit}>
				<div>
					<label>Match Type: </label>
					<select
						value={matchType}
						onChange={(e) => setMatchType(e.target.value)}
						required
					>
						<option value="FOOTBALL">Football</option>
						<option value="HOCKEY">Hockey</option>
					</select>
				</div>

				<div>
					<label>Home Team: </label>
					<select
						value={homeTeam}
						onChange={(e) => setHomeTeam(e.target.value)}
						required
					>
						<option value="">Select Home Team</option>
						{filteredTeams.map((team) => (
							<option key={team.id} value={team.id}>
								{team.name}
							</option>
						))}
					</select>
				</div>

				<div>
					<label>Away Team: </label>
					<select
						value={awayTeam}
						onChange={(e) => setAwayTeam(e.target.value)}
						required
					>
						<option value="">Select Away Team</option>
						{filteredTeams.map((team) => (
							<option key={team.id} value={team.id}>
								{team.name}
							</option>
						))}
					</select>
				</div>

				<div>
					<label>Tournament: </label>
					<select
						value={tournament}
						onChange={(e) => setTournament(e.target.value)}
						required
					>
						<option value="">Select Tournament</option>
						{filteredTournaments.map((tournament) => (
							<option key={tournament.id} value={tournament.id}>
								{tournament.name}
							</option>
						))}
					</select>
				</div>

				<div>
					<label>Date: </label>
					<input
						type="datetime-local"
						value={date}
						onChange={(e) => setDate(e.target.value)}
						required
					/>
				</div>

				<div>
					<label>Points for Home Win: </label>
					<input
						type="number"
						value={homeTeamPoints}
						onChange={(e) => setHomeTeamPoints(parseInt(e.target.value, 10))}
						required
					/>
				</div>

				<div>
					<label>Points for Away Win: </label>
					<input
						type="number"
						value={awayTeamPoints}
						onChange={(e) => setAwayTeamPoints(parseInt(e.target.value, 10))}
						required
					/>
				</div>

				<div>
					<label>Points for Draw: </label>
					<input
						type="number"
						value={drawPoints}
						onChange={(e) => setDrawPoints(parseInt(e.target.value, 10))}
						required
					/>
				</div>

				<div>
					<label>SportDB API ID: </label>
					<input
						type="number"
						value={sportDbApiId}
						onChange={(e) => setSportDbApiId(parseInt(e.target.value, 10))}
						required
					/>
				</div>

				<div>
					<label>Match Status:</label>
					<select
						value={matchStatus}
						onChange={(e) => setMatchStatus(e.target.value)}
						required
					>
						<option value="NOT_STARTED">Not Started</option>
						<option value="IN_PROGRESS">In Progress</option>
						<option value="FINISHED">Finished</option>
					</select>
				</div>

				<button type="submit">Create Match</button>
			</form>
		</div>
	);
};

export default CreateMatch;
